/**
 * Convert ExtraHorizon user data to CurrentUser format
 * for backwards compatibility with existing components
 */

import { CurrentUser } from "lib/auth/types";

import { ExhUser } from "../types";

import { exhRoleNameToRole } from "./role";

/**
 * Convert ExtraHorizon user to CurrentUser format
 * @param exhUser - ExtraHorizon user from SDK
 * @returns CurrentUser compatible format
 */
export const convertExhUserToCurrentUser = (exhUser: ExhUser | null): CurrentUser | null => {
  if (!exhUser) {
    return null;
  }

  const primaryEnlistment = exhUser.staffEnlistments?.[0];
  const primaryGroupId = primaryEnlistment?.groupId;
  const primaryRoleName = primaryEnlistment?.roles?.[0]?.name;

  return {
    id: exhUser.id,
    email: exhUser.email || "",
    firstName: exhUser.profile?.firstName || "",
    lastName: exhUser.profile?.lastName || "",
    hospital: {
      id: primaryGroupId || "exh-hospital",
      name: "ExtraHorizon Organization",
    },
    role: exhRoleNameToRole(primaryRoleName),
  };
};
